import request from '@/utils/request'

let SecondhandApi = {
  categoryIndex(data, errorback) {
    return request._get('/shop/secondhand.category/index', data, errorback);
  },
  categoryAdd(data, errorback) {
    return request._post('/shop/secondhand.category/add', data, errorback);
  },
  getCategoryEdit(data, errorback) {
    return request._get('/shop/secondhand.category/edit', data, errorback);
  },
  setCategoryEdit(data, errorback) {
    return request._post('/shop/secondhand.category/edit', data, errorback);
  },
  categoryDelete(data, errorback) {
    return request._post('/shop/secondhand.category/delete', data, errorback);
  },


  finenessIndex(data, errorback) {
    return request._get('/shop/secondhand.fineness/index', data, errorback);
  },

  finenessAll(data, errorback) {
    return request._get('/shop/secondhand.fineness/getAll', data, errorback);
  },
  finenessAdd(data, errorback) {
    return request._post('/shop/secondhand.fineness/add', data, errorback);
  },
  setFinenessEdit(data, errorback) {
    return request._post('/shop/secondhand.fineness/edit', data, errorback);
  },
  getFinenessEdit(data, errorback) {
    return request._get('/shop/secondhand.fineness/edit', data, errorback);
  },
  finenessDelete(data, errorback) {
    return request._post('/shop/secondhand.fineness/delete', data, errorback);
  },



  attachmentIndex(data, errorback) {
    return request._get('/shop/secondhand.attachment/index', data, errorback);
  },
  attachmentAll(data, errorback) {
    return request._get('/shop/secondhand.attachment/getAll', data, errorback);
  },
  attachmentAdd(data, errorback) {
    return request._post('/shop/secondhand.attachment/add', data, errorback);
  },
  setAttachmentEdit(data, errorback) {
    return request._post('/shop/secondhand.attachment/edit', data, errorback);
  },
  getAttachmentEdit(data, errorback) {
    return request._get('/shop/secondhand.attachment/edit', data, errorback);
  },
  attachmentDelete(data, errorback) {
    return request._post('/shop/secondhand.attachment/delete', data, errorback);
  },


  secondhandIndex(data, errorback) {
    return request._get('/shop/secondhand.product/index', data, errorback);
  },
  secondhandDetail(data, errorback) {
    return request._get('/shop/secondhand.product/detail', data, errorback);
  },
  secondhandAudit(data, errorback) {
    return request._post('/shop/secondhand.product/audit', data, errorback);
  },
  secondhandEdit(data, errorback) {
    return request._post('/shop/secondhand.product/edit', data, errorback);
  },
  secondhandDelete(data, errorback) {
    return request._post('/shop/secondhand.product/delete', data, errorback);
  },
  secondhandStatus(data, errorback) {
    return request._post('/shop/secondhand.product/status', data, errorback);
  },

  categoryAll(data, errorback) {
    return request._get('/shop/secondhand.category/getAll', data, errorback);
  },
  cityAll(data, errorback) {
    return request._get('/shop/city.city/getAll', data, errorback);
  },

}
export default SecondhandApi;



// WEBPACK FOOTER //
// ./src/api/secondhand.js